export default __webpack_public_path__ + "static/media/Skateboarding.75ec4901.webp";